<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.user.update.title"></sm-page-header>
  <!-- content -->
  <div class="content" *ngIf="!formDateLoading">
    <div class="flex items-center gap-6 mb-6 px-4">
      <div class="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center border border-gray-300">
        <i class="pi pi-user text-4xl text-gray-500"></i>
      </div>
      <div class="flex flex-col">
        <span class="text-xl font-semibold">{{ userDto.firstName }} {{ userDto.lastName }}</span>
        <span class="text-gray-500">{{ userDto.email }}</span>
      </div>
    </div>
    <sm-form-builder [formObject]="formObject" class="w-full px-4"></sm-form-builder>
    <div class="flex justify-end gap-2 mb-6" *ngIf="!isInspectMode()">
      <p-button label="Modifier" (click)="updateUser()" />
      <p-button label="Annuler" severity="secondary" (click)="cancelUserEdit()" />
    </div>
      <div class="flex flex-col justify-start gap-2 mb-10" *ngIf="!isInspectMode()">
        <h1>{{ 'settings.user.password.title' | translate }}</h1>
        <p>{{ 'settings.user.password.description' | translate }}</p>
        <p-button severity="success" label="{{ 'settings.user.password.button' | translate }}" (click)="resetPassword()"></p-button>
      </div>
    <p-tabs [(value)]="selectedTab" (valueChange)="onTabChange($event)" scrollable class="mt-4 bg-transparent">
      <p-tablist>
        <p-tab value="0">{{ 'settings.userInfo.tabs.roles' | translate }}</p-tab>
        <p-tab value="1">{{ 'settings.userInfo.tabs.acs' | translate }}</p-tab>
        <p-tab value="2">{{ 'settings.userInfo.tabs.coms' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="flex justify-between items-center mb-2">
            <h3 class="text-lg font-semibold">{{ 'settings.userInfo.tabs.roles' | translate }}</h3>
            <p-button label="Editer les rôles" icon="pi pi-pencil" (click)="openEditRolesDialog()"
              *ngIf="!isInspectMode()"></p-button>
          </div>
          <sm-data-table-builder [dataTableObject]="rolesTableObject" [datas]="userRolesTableData"
            [loading]="formDateLoading"></sm-data-table-builder>
        </p-tabpanel>
        <p-tabpanel value="1">
          <div class="flex justify-between items-center mb-2">
            <h3 class="text-lg font-semibold">{{ 'settings.userInfo.tabs.acs' | translate }}</h3>
            <p-button label="Editer les ACs" icon="pi pi-pencil" (click)="openEditAcsDialog()"
              *ngIf="!isInspectMode()"></p-button>
          </div>
          <sm-data-table-builder [dataTableObject]="acsTableObject" [datas]="userAcs.value"
            [loading]="formDateLoading"></sm-data-table-builder>
        </p-tabpanel>
        <p-tabpanel value="2">
          <div class="flex justify-between items-center mb-2">
            <h3 class="text-lg font-semibold">{{ 'settings.userInfo.tabs.coms' | translate }}</h3>
            <p-button label="Editer les Commissions" icon="pi pi-pencil" (click)="openEditComsDialog()"
              *ngIf="!isInspectMode() && isAdmin"></p-button>
          </div>
          <sm-data-table-builder [dataTableObject]="comsTableObject" [datas]="userComs"
            [loading]="formDateLoading"></sm-data-table-builder>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
  <sm-spinner [loading]="formDateLoading"></sm-spinner>
  <sm-dialog [dialog]="userDialog" [(visible)]="dialogVisible"></sm-dialog>
  <sm-dialog [dialog]="editDialog" [(visible)]="editDialogVisible" (onHide)="editDialogVisible = false"></sm-dialog>
</div>